export default __webpack_public_path__ + "65e3854e418162de640bec34e2761a00.png";